<template>
    <div class="container">
      <div class="row">
            <div class="">
              <favorites></favorites>
            </div>
        </div>
        <div class="row products-list">
            <div v-for="product in products" class="col-sm-6 col-md-4">
                <product :product="product"></product>
            </div>
        </div>
        <div class="row">
            <infinite-loading @infinite="onInfinite" ref="infiniteLoading" :distance="100">
                <div slot="no-results">
                    <div class="col-sm-offset-3 col-sm-6">
                      <p style="color: #f19000">
                          Pour tout autre article ou demande spécifique
                        </p>
                        <p>
                            <a class="btn btn-lg btn-primary btn-no-more" href="/contact">Contactez-nous</a>
                        </p>
                    </div>
                </div>
                <div slot="no-more">
                    <div class="col-sm-offset-3 col-sm-6">
                        <p style="color: #f19000">
                          Pour tout autre article ou demande spécifique
                        </p>
                        <p>
                            <a class="btn btn-lg btn-primary btn-no-more" href="/contact">Contactez-nous</a>
                        </p>
                    </div>
                </div>
            </infinite-loading>
            <back-to-top v-if="products.length > 15"></back-to-top>
        </div>
    </div>
</template>

<script>
  import store from './../store'
  import trunk8 from 'trunk8'
  import axios from 'axios'
  import _ from 'lodash'
  import queryString from 'query-string'
  import InfiniteLoading from 'vue-infinite-loading';
  import Product from './Product.vue'
  import Favorites from './Favorites.vue'
  import BackToTop from './BackToTop.vue'

  export default {
    name: 'products-page',
    components: {
      Product,
      InfiniteLoading,
      BackToTop,
      Favorites
    },
    data () {
      return {
        state: store.state,
        products: [],
        pagination: {},
        tag: {
          id: null,
          name: '',
          slug: ''
        }
      }
    },
    computed: {
      infiniteScrollDisabled () {
        return this.pagination.hasOwnProperty('next_page_url')
          ? (this.pagination.next_page_url === null)
          : true
      },
      pageToCall () {
        return (this.pagination.hasOwnProperty('next_page_url') && this.pagination.next_page_url !== null)
          ? this.pagination.current_page + 1
          : 1
      },
    },
    methods: {
      truncateDescription () {
        jQuery(document).ready($ => {
          $('.product-description').trunk8({ lines: 2 })
          $(window).resize(_.debounce(() => {
            $('.product-description').trunk8({ lines: 2 })
          }, 150))
        })
      },
      truncateTags () {
        jQuery(document).ready($ => {
          $('.product-tags').trunk8({
            lines: 3,
            tooltip: false,
            parseHTML: true
          })
          $(window).resize(_.debounce(() => {
            $('.product-tags').trunk8({
              lines: 2,
              tooltip: false,
              parseHTML: true
            })
          }, 150))
        })
      },
      getTagFromLocation () {
        if ('tag' in queryString.parse(window.location.search)) {
          axios.get(`/api/tags?slug=${queryString.parse(window.location.search).tag}`)
            .then(response => {
              this.tag = response.data
            })
            .catch(error => console.log(error))
        }

        return ('tag' in queryString.parse(window.location.search))
          ? queryString.parse(window.location.search).tag
          : ''
      },
      getIsFavPageFromLocation () {
        if ('fav[]' in queryString.parse(window.location.search)
          && queryString.parse(window.location.search)['fav[]']) {
          store.setIsFavPage(1)
        }
      },
      parseProductsAndPagination (data) {
        this.products = this.products.concat(data.data)
        let pagination = Object.assign({}, data)
        delete pagination.data
        this.pagination = pagination
      },
      getInitialState () {
        this.parseProductsAndPagination(window.initialState)
      },
      onInfinite ($state) {
        let pageToCall = this.pageToCall
        if (pageToCall !== 1) {
          axios.get('/api/products', {
            params: {
              page: this.pageToCall,
              tag: this.getTagFromLocation(),
              fav: store.getIsFavPage() ? store.getFavoriteProducts() : ''
            }
          }).then(response => {
            this.parseProductsAndPagination(response.data)
            $state.loaded()
            jQuery(window).trigger('resize')
          }).catch(error => {
            console.log(error)
            $state.complete()
          })
        } else {
          $state.complete()
        }
      }
    },
    mounted () {
      this.getIsFavPageFromLocation()
      this.getTagFromLocation()
      this.getInitialState()
      this.truncateDescription()
      this.truncateTags()
    }
  }
</script>
